import { render, staticRenderFns } from "./VitaminsModal.vue?vue&type=template&id=437cbde1"
import script from "./VitaminsModal.vue?vue&type=script&lang=js"
export * from "./VitaminsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports